import React from "react";
import Footer from "./Footer";
import Navbar2 from "./Navbar2";

const Layout2 = (props) => {
  return (
    <>
      <Navbar2 />
      {props.children}
      <Footer />
    </>
  );
};

export default Layout2;
